'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTabItem = require('./CwTabItem.scss');

var _CwTabItem2 = _interopRequireDefault(_CwTabItem);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwTabItem = function CwTabItem(props) {
  var _cx;

  var handleClick = function handleClick() {
    props.onClick(props.tab.id);
  };

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _CwTabItem2.default.tab, !props.isSelected), (0, _defineProperty3.default)(_cx, _CwTabItem2.default.selectedTab, props.isSelected), (0, _defineProperty3.default)(_cx, _CwTabItem2.default.compactTab, !props.isSelected && props.isCompact), (0, _defineProperty3.default)(_cx, _CwTabItem2.default.compactSelectedTab, props.isSelected && props.isCompact), _cx)),
      onClick: props.isSelected ? null : handleClick },
    props.tab.name
  );
};

CwTabItem.propTypes = {
  tab: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  }),
  isSelected: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  isCompact: _propTypes2.default.bool
};

exports.default = CwTabItem;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtabs/CwTabItem.js
// module id = 857
// module chunks = 10